module.exports = __webpack_public_path__ + "static/details-7-8554144a421d17e2a529c81735369d01.jpg";